'use client';

import { useState } from 'react';

import type { Dispatch, SetStateAction } from 'react';

export interface HeaderController {
  isTransparent: boolean;
  setIsTransparent: Dispatch<SetStateAction<boolean>>;
  isScrolling: boolean;
  setIsScrolling: Dispatch<SetStateAction<boolean>>;
  mode: 'dark' | 'light';
  setMode: Dispatch<SetStateAction<HeaderController['mode']>>;
}

export type UseHeaderController = () => HeaderController;

export const useHeaderController: UseHeaderController = () => {
  const [isTransparent, setIsTransparent] = useState( false );
  const [isScrolling, setIsScrolling] = useState( false );
  const [mode, setMode] = useState<HeaderController['mode']>( 'light' );

  return {
    isTransparent,
    setIsTransparent,
    isScrolling,
    setIsScrolling,
    mode,
    setMode,
  };
};
